const events = new Set(['source-read-failed', 'source-write-failed', 'source-preview-failed', 'source-delete-failed', 'statement-review-failed', 'statement-update-start', 'statement-update-complete', 'statement-update-failed']);

// Never pass records or raw errors to the console: bank errors can contain PII.
export function bankingDiagnostic(event, error = null) {
  if (process.env.NODE_ENV === 'production' || !events.has(event)) return;
  const message = typeof error?.message === 'string' ? error.message : '';
  const code = !error ? 'ok'
    : /IO error|NewWritableFile|\.ldb|UnknownError/i.test(message + ' ' + error?.name) ? 'browser_storage_io'
      : /quota/i.test(message + ' ' + error?.name) ? 'browser_storage_quota'
        : /identity|repeats|correspondence/i.test(message) ? 'source_identity_conflict'
          : /missing|not found/i.test(message) ? 'retained_source_unavailable'
            : /changed|stale|saving/i.test(message) ? 'saved_review_changed' : 'operation_failed';
  const output = { event, code };
  if (error) console.warn('[Invoice Studio][Banking]', output);
  else console.info('[Invoice Studio][Banking]', output);
}
